// extracted by mini-css-extract-plugin
export default {"button":"e65NnEkekGsBhSF-iGnIa"};